const Unauthorized = () => {
  return (
    <div style={{ marginLeft: '4rem' }}>
      <h3>Your account is not authorized to access this page.</h3>
    </div>
  )
}

export default Unauthorized
